export const parseNumericString = (number_) => {
  return Number(number_.replace(/,/g, ""));
};

export const calculateDiscountPercentage = (originalPrice, discountedPrice) => {
  const original = parseNumericString(originalPrice);
  const discounted = parseNumericString(discountedPrice);

  if (original === discounted) {
    return 0;
  }

  const discount = ((original - discounted) / original) * 100;

  return Math.round(discount);
};

export const formatCurrencyWithSign = (amount, currency = "PKR") => {
  // Format without rounding, show exact value with commas
  if (typeof amount === "string") {
    return `${currency} ${amount}`;
  }

  return `${currency} ${Math.round(amount).toLocaleString("en-US", {
    maximumFractionDigits: 0,
  })}`;
};
